import { useState, useEffect, useRef, useCallback, Fragment, useMemo } from "react";
import style from "./SelectOption.module.scss";
import { v4 } from "uuid";
import * as YStyled from "../../../Styleds";
import styled from "styled-components";
export const TimeDiv = styled.div`
                scroll-snap-align: start;
                height: ${props => props.height}px;
                min-height: ${props => props.height}px;
                max-height: ${props => props.height}px;
                display: flex;
                justify-content: center;
                align-items: center;
`;
const SelectOption = ({list=[],dispplayKey, onSelect=()=>{} }) => {
    const timeHeight = 35;
    return (
        <div className={style.timePicker}>
            <div className={style.hour} style={{ height: `${(timeHeight * 7)}px` }} onScroll={e => {
                const ind = Math.floor(e.target.scrollTop / timeHeight);
                onSelect(list[ind]);
            }}>
                <TimeDiv height={timeHeight} />
                <TimeDiv height={timeHeight} />
                <TimeDiv height={timeHeight} />
                {list.map((v, k) => {
                    return <TimeDiv height={timeHeight} key={k}>
                        <YStyled.Span size={22} fontWeight={400}>{v[dispplayKey]}</YStyled.Span>
                    </TimeDiv>
                })}
                <TimeDiv height={timeHeight} />
                <TimeDiv height={timeHeight} />
                <TimeDiv height={timeHeight} />
            </div>
            <div className={style.mask}></div>
        </div>
    );
}

export default SelectOption;